
import createPanZoom from "panzoom";
class GalleryPopup extends HTMLElement {
    constructor() {
        super();
        this.mainSlider;
        this.thumbSlider;
        this.mainSliderWrapper = this.querySelector('[data-role="popup-main-slider"]');
        this.thumbSlideWrapper = this.querySelector('[data-role="popup-thumb-slider"]');
        this.thumbDots = this.querySelectorAll('[data-role="thumbs-dots"] button');
        this.arrowBtns = this.querySelectorAll('[data-role="popup-slider-arrows"] [data-behave]');
        this.mainImages = Array.from(this.querySelectorAll('[data-image]'));
        this.closeButtons = Array.from(this.querySelectorAll('[data-role="popup-close"]'));

        this.closeButtons.forEach((el) => el.addEventListener('click', this.hidePopup.bind(this)));

        window.Slider ? this.initalizeSlider.call(this, window.Slider) : "";
        document.addEventListener("custom:keenLoaded", (e) => {
            this.initalizeSlider.call(this, window.Slider)
        })

        document.addEventListener("custom:galleryPopupDisplay", (e) => {
            this.classList.remove("hidden");
            setTimeout(() => {
                document.body.style.overflow = 'hidden';
                let mediaIndex = Array.from(this.querySelectorAll('[data-media]')).indexOf(Array.from(this.querySelectorAll('[data-media]')).find(el => el.dataset.media == e.detail.media));
                console.log(mediaIndex, "here")
                this.mainSlider.update({ loop: true }, mediaIndex);
            }, 0)
        })
        this.mainImages.forEach((el, ind) => el.addEventListener('click', () => {
            document.dispatchEvent(new CustomEvent("custom:zoomDisplay", { detail: { index: ind } }));
        }))
        document.addEventListener("custom:galleryUpdate", (e) => {
            this.mainSlider.moveToIdx(e.detail.index);
        })
        this.mainSlider.on("slideChanged", (slide) => {
            let currentActiveIndex = slide.track.details.rel;
            this.syncSlider(currentActiveIndex);
        })
        this.thumbSlider.on("slideChanged", (slide) => {
            let activeInd = slide.track.details.rel;
            slide.slides.forEach((el, index) => {
                if (activeInd == index) {
                    el.classList.add("active-thumb")
                } else {
                    el.classList.remove("active-thumb")
                }
            })
        })

        this.thumbSlideWrapper.querySelectorAll(".keen-slider__slide").forEach((el, ind) => {
            el.addEventListener('click', () => {
                this.thumbSlider.moveToIdx(ind);
                this.mainSlider.moveToIdx(ind);
                this.thumbDots.forEach((el, index) => ind == index ? el.classList.add("active") : el.classList.remove("active"));
            })
        })

        this.thumbDots.forEach((el, index) => {
            el.addEventListener('click', () => {
                this.thumbDots.forEach((el, ind) => ind != index ? el.classList.remove("active") : el.classList.add("active"));
                this.thumbSlider.moveToIdx(index);
                this.mainSlider.moveToIdx(index);
            })
        })

        this.arrowBtns.forEach((el) => {
            el.addEventListener('click', () => {
                if (el.dataset.behave == 'next') {
                    this.mainSlider.next()
                } else {
                    this.mainSlider.prev();
                }

            })
        })
    }
    WheelControls(slider) {
        var touchTimeout;
        var position;
        var wheelActive;

        function dispatch(e, name) {
            position.x -= e.deltaX;
            position.y -= e.deltaY;
            slider.container.dispatchEvent(
                new CustomEvent(name, {
                    detail: {
                        x: position.x,
                        y: position.y,
                    },
                })
            );
        }

        function wheelStart(e) {
            position = {
                x: e.pageX,
                y: e.pageY,
            };
            dispatch(e, 'ksDragStart');
        }

        function wheel(e) {
            if (e.deltaY == -0) {
                dispatch(e, 'ksDrag');
            }
        }

        function wheelEnd(e) {
            dispatch(e, 'ksDragEnd');
        }

        function eventWheel(e) {
            if (!wheelActive) {
                wheelStart(e);
                wheelActive = true;
            }
            wheel(e);
            clearTimeout(touchTimeout);
            touchTimeout = setTimeout(() => {
                wheelActive = false;
                wheelEnd(e);
            }, 50);
        }

        slider.on('created', () => {
            slider.container.addEventListener(
                'wheel',
                (e) => {
                    if (e.deltaY != -0) {
                        slider.container.removeEventListener('wheel', () => { });
                    } else {
                        eventWheel(e);
                    }
                },
                { passive: false }
            );
        },);
    }
    initalizeSlider(Slider) {
        this.mainSlider = new Slider(this.mainSliderWrapper, {
            loop: true,
            slides: {
                perView: 1,
            }
        }, [this.WheelControls]);
        this.thumbSlider = new Slider(this.thumbSlideWrapper, {
            loop: true,
            slides: {
                perView: 4.8,
                spacing: 8
            }, breakpoints: {
                '(min-width: 500px)': {
                    slides: {
                        perView: 5,
                        spacing: 8
                    }
                },
            },
        }, [this.WheelControls]);
    }
    syncSlider(activeInd) {
        this.thumbSlider.moveToIdx(activeInd);
        this.thumbDots.forEach((el, ind) => ind != activeInd ? el.classList.remove("active") : el.classList.add("active"));
    }
    hidePopup() {
        this.classList.add("hidden");
        document.body.style.overflow = 'auto';
    }
};

customElements.define("gallery-popup", GalleryPopup);

class ZoomBox extends HTMLElement {
    constructor() {
        super();
        this.mainSliderWrapper = this.querySelector('[data-role="zoom-slider"]');
        this.closeButtons = this.querySelectorAll('[data-role="close-zoom"]');
        this.arrowBtns = this.querySelectorAll('[data-role="zoom-slider-arrows"] [data-behave]');
        this.zoomInstances = [];
        document.addEventListener("custom:zoomDisplay", this.animatePopup.bind(this));

        Array.from(this.querySelectorAll('[data-role="zoom-image"]')).forEach((el) => {
            el.addEventListener('dblclick', this.removeZoomEffectAndClose.bind(this));
            el.addEventListener('touchstart', this.tapHandler.bind(this));
        })
        this.closeButtons.forEach((el) => el.addEventListener('click', this.closePopup.bind(this)));
        this.arrowBtns.forEach((el) => {
            el.addEventListener('click', () => {
                if (el.dataset.behave == 'next') {
                    this.mainSlider.next();
                } else {
                    this.mainSlider.prev();
                }

            })
        })
    }
    tapHandler(e) {
        if (!tapedTwice) {
            tapedTwice = true;
            setTimeout(function () { tapedTwice = false; }, 300);
            return false;
        }
        e.preventDefault();
        this.removeZoomEffectAndClose.call(this);
    }
    animatePopup(e) {
        this.classList.remove("hidden");
        this.sliderInit(window.Slider, e.detail.index);
    }
    closePopup() {
        this.classList.add('hidden');
        this.mainSlider.destroy();
        this.removeZoomEffect();
    }
    removeZoomEffect() {
        this.zoomInstances.forEach(el => el.dispose());
        Array.from(this.querySelectorAll('[data-role="zoom-image"]')).forEach(el => {
            el.style.tranformOrigin = 'unset';
            el.style.transform = 'unset';
        })
    }
    removeZoomEffectAndClose() {
        this.zoomInstances.forEach(el => el.dispose());
        Array.from(this.querySelectorAll('[data-role="zoom-image"]')).forEach(el => {
            el.style.tranformOrigin = 'unset';
            el.style.transform = 'unset';
        });
        this.mainSlider.destroy();
        this.classList.add("hidden");
    }
    sliderInit(Slider, ind) {
        this.mainSlider = new Slider(this.mainSliderWrapper, {
            loop: true,
            slideChanged: (slider) => {
                this.removeZoomEffect();
                let currentSlide = slider.track.details.rel;
                let zoomImage = this.querySelectorAll('[data-role="zoom-image"]')[currentSlide];
                let intialZoomVal = 1.2;
                if (window.innerWidth < 768) {
                    intialZoomVal = 2;
                }
                let instance = createPanZoom(zoomImage, {
                    maxZoom: intialZoomVal,
                    bounds: true,
                    boundsPadding: 0.9,
                    onDoubleClick: function (e) {
                        return false;
                    }
                });
                this.zoomInstances.push(instance);
                let centerX = zoomImage.offsetWidth / 2;
                let centerY = zoomImage.offsetHeight / 2;
                instance.smoothZoom(centerX, centerY, intialZoomVal);
            },
            created: (slider) => {
                this.removeZoomEffect();
                let currentSlide = slider.track.details.abs;
                let zoomImage = this.querySelectorAll('[data-role="zoom-image"]')[currentSlide];
                let intialZoomVal = 1.2;
                if (window.innerWidth < 768) {
                    intialZoomVal = 2;
                }
                let instance = createPanZoom(zoomImage, {
                    maxZoom: intialZoomVal,
                    bounds: true,
                    boundsPadding: 0.9,
                    onDoubleClick: function (e) {
                        return false;
                    }
                });
                this.zoomInstances.push(instance);
                let centerX = zoomImage.offsetWidth / 2;
                let centerY = zoomImage.offsetHeight / 2;
                instance.smoothZoom(centerX, centerY, intialZoomVal);
            },
            initial: ind,
            slides: {
                perView: 1,
            },
        })
    }
}
customElements.define("zoom-box", ZoomBox);